import React from 'react';

function Content() {
  return (
    <section className="tc-post-content-style1">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="info">
              <div
  className="breadcromb wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  <a href="#"> Home </a>
  <span className="icon">/</span>
  <a href="#"> Projects </a>
  <span className="icon">/</span>
  <a href="#"> Redant Studio LLP </a>
</div>

<h6
  className="fsz-24 fw-600 mb-60 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  Creating modern, functional, and inspiring spaces with
  <span className="color-orange1"> Redant Studio LLP</span> — where
  design meets purpose and innovation transforms everyday living.
</h6>

<div
  className="text fsz-14 color-666 mb-70 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  <span className="lg-letter"> R </span>
  edant Studio LLP is dedicated to delivering high-quality architecture
  and interior design solutions tailored to modern lifestyles. We focus
  on blending creativity with functionality to design spaces that are
  not only visually stunning but also highly practical.
  
  From residential interiors to commercial environments, our approach
  is rooted in understanding client needs, optimizing space, and
  executing with precision. Every project we undertake reflects our
  commitment to quality, innovation, and attention to detail.

  Our goal is simple — to transform ideas into spaces that inspire,
  elevate, and perform.
</div>

<h6
  className="fsz-24 fw-600 mb-30 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  Our Approach to Design
</h6>

<div
  className="text fsz-14 color-666 mb-70 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  At Redant Studio LLP, we believe great design starts with clarity.
  We analyze, plan, and execute every project with a strong focus on
  user experience and long-term value.

  <a href="#" className="text-info text-decoration-underline">
    Discover our projects
  </a>{" "}
  and see how we turn concepts into reality through innovative design,
  premium materials, and expert craftsmanship.
</div>
            </div>
          </div>
        </div>
        <div className="imgs mb-40">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="item text-center mb-50 wow zoomIn slow"
                data-wow-delay="0.2s"
              >
                <div className="img th-450 radius-6 overflow-hidden">
                  <img
                    src="/innerpages/assets/img/blog/b14.jpg"
                    alt=""
                    className="img-cover"
                  />
                </div>
                <p className="fsz-14 color-666 fst-italic mt-30">
                  images by @logancee on unsplash.com
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="item text-center mb-50 wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <div className="img th-450 radius-6 overflow-hidden">
                  <img
                    src="/innerpages/assets/img/blog/b15.jpg"
                    alt=""
                    className="img-cover"
                  />
                </div>
                <p className="fsz-14 color-666 fst-italic mt-30">
                  images by @moussa on unsplash.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h6
  className="fsz-24 fw-600 mb-30 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  Designing Spaces That Inspire
</h6>

<div
  className="text fsz-14 color-666 mb-40 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  At Redant Studio LLP, we create spaces that balance aesthetics,
  functionality, and innovation. Our designs are thoughtfully crafted
  to enhance everyday living while maintaining a strong visual identity.
</div>

<ul
  className="list-styled color-666 fsz-14 lh-5 mb-40 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  <li>
    Intelligent space planning that maximizes efficiency and comfort
  </li>
  <li>
    Modern architectural and interior solutions tailored to client needs
  </li>
  <li>
    Strategic use of lighting, textures, and materials for a premium finish
  </li>
  <li>
    Customized designs that reflect lifestyle, brand, and purpose
  </li>
</ul>

<div
  className="text fsz-14 color-666 mb-90 wow fadeInUp slow"
  data-wow-delay="0.2s"
>
  With a strong focus on quality and innovation, Redant Studio LLP transforms
  concepts into impactful spaces. Whether residential or commercial, we deliver
  designs that are functional, timeless, and visually compelling.
</div>
            <div
              className="share-content wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="tags">
                    <a href="#"> Architecture </a>
                    <a href="#"> Building </a>
                    <a href="#"> Wooden </a>
                    <a href="#"> Inspiration </a>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="share mt-4 mt-lg-0 justify-content-lg-end">
                    <span className="txt me-3"> Share on </span>
                    <div className="links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="editor wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="row">
                <div className="col-lg-2">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/icon.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="cont mt-4 mt-lg-0">
                    <h6 className="fsz-18 fw-bold mb-2">Shivan Raj</h6>
                    <small className="fsz-12 text-uppercase color-666">
                      School Principal
                    </small>
                    <div className="text fsz-14 fw-500 mt-20">
                     "The complete renovation of all blocks in Valparai by RED ANT STUDIO LLP has brought new life to our campus. Their team carefully studied the unique climatic conditions of Valparai and delivered designs perfectly suited to its environment. 
                     Every block now feels modern, functional, and resilient, backed by their dedication, attention to detail, and seamless project coordination. We are truly grateful for their commitment to quality and community impact."
                    </div>
                    <div className="social-links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="editor wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="row">
                <div className="col-lg-2">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/icon.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="cont mt-4 mt-lg-0">
                    <h6 className="fsz-18 fw-bold mb-2">Local Community Representatives</h6>
                    <small className="fsz-12 text-uppercase color-666">
                      Allikulam Lake
                    </small>
                    <div className="text fsz-14 fw-500 mt-20">
                      "The rejuvenation of our community pond by RED ANT STUDIO LLP has restored both its ecological health and its cultural value. 
                      Their thoughtful design, sustainable approach, and hands-on coordination brought the space back to life. Today, the pond stands as a beautiful public asset, 
                      and we are deeply grateful for their impactful work."

                    </div>
                    <div className="social-links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="editor wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="row">
                <div className="col-lg-2">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/icon.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="cont mt-4 mt-lg-0">
                    <h6 className="fsz-18 fw-bold mb-2">School Management</h6>
                    <small className="fsz-12 text-uppercase color-666">
                      Govt Hobart Muslim Hr Sec school
                    </small>
                    <div className="text fsz-14 fw-500 mt-20">
                      "Our new lab interiors designed by RED ANT STUDIO LLP have significantly improved workflow, safety, and efficiency. 
                      The team understood the technical requirements and delivered a clean, future-ready environment with precision. 
                      It’s a space that truly supports high-performance work, and we couldn’t be more satisfied."
                    </div>
                    <div className="social-links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="editor wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="row">
                <div className="col-lg-2">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/icon.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="cont mt-4 mt-lg-0">
                    <h6 className="fsz-18 fw-bold mb-2">Hema Priya</h6>
                    <small className="fsz-12 text-uppercase color-666">
                      Principal
                    </small>
                    <div className="text fsz-14 fw-500 mt-20">
                      "RED ANT STUDIO LLP transformed our vision for a modern, student-centric school building into a vibrant learning environment. 
                      Their team understood the heritage and purpose of Lady Willingdon and delivered a design that is functional, safe, and inspiring for our students. 
                      The project was executed with remarkable professionalism, clarity, and commitment."
                    </div>
                    <div className="social-links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="editor wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="row">
                <div className="col-lg-2">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/icon.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="cont mt-4 mt-lg-0">
                    <h6 className="fsz-18 fw-bold mb-2">Ramakrishna Mission</h6>
                    <small className="fsz-12 text-uppercase color-666">
                      Bengaluru
                    </small>
                    <div className="text fsz-14 fw-500 mt-20">
                      "RED ANT STUDIO LLP served as both the Architects and Project Management Consultants for our new Teachers’ Quarters in Bengaluru, and their contribution has been outstanding. 
                      They blended practicality with calm, well-lit design that reflects the ethos of the Mission. Every aspect—from planning to execution—was handled with discipline, transparency, 
                      and genuine commitment. The result is a comfortable, efficient living environment that our teachers deeply appreciate."
                    </div>
                    <div className="social-links">
                      <a href="#">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-blogger"></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-discord"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="related-posts">
              <div className="title mb-70">
                <div
                  className="row align-items-center wow fadeInUp slow"
                  data-wow-delay="0.2s"
                >
                  <div className="col-lg-8">
                    <h3 className="fsz-45 text-capitalize"> Related Posts </h3>
                  </div>
                  <div className="col-lg-4 mt-4 mt-lg-0">
                    <div className="arrows me-lg-0 ms-lg-auto">
                      <div className="swiper-button-prev"></div>
                      <div className="swiper-button-next"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="related-slider wow fadeInUp slow"
                data-wow-delay="0.2s"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="post-card">
                      <a
                        href="#"
                        className="img th-280 radius-7 overflow-hidden d-block"
                      >
                        <img
                          src="/innerpages/assets/img/blog/b3.jpg"
                          alt=""
                          className="img-cover"
                        />
                      </a>
                      <div className="info pt-30">
                        <div className="tags color-666 text-uppercase fsz-12">
                          <a href="#" className="color-orange1">
                            architecture, guide
                          </a>
                          <span className="circle icon-3 bg-666 rounded-circle mx-3"></span>
                          <a href="#"> march 22, 2024 </a>
                        </div>
                        <h3 className="title mt-15">
                          <a href="#" className="hover-orange1 fsz-24">
                            How to handle the day light in <br /> Vray for best
                            reality
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="post-card">
                      <a
                        href="#"
                        className="img th-280 radius-7 overflow-hidden d-block"
                      >
                        <img
                          src="/innerpages/assets/img/blog/b4.jpg"
                          alt=""
                          className="img-cover"
                        />
                      </a>
                      <div className="info pt-30">
                        <div className="tags color-666 text-uppercase fsz-12">
                          <a href="#" className="color-orange1">
                            inspiration, interior
                          </a>
                          <span className="circle icon-3 bg-666 rounded-circle mx-3"></span>
                          <a href="#"> march 7, 2024 </a>
                        </div>
                        <h3 className="title mt-15">
                          <a href="#" className="hover-orange1 fsz-24">
                            Sustainable Design Award 2024
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Content;
